export const Partners = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3153 7.37914L8.93705 9.32957C8.35247 9.66706 7.60501 9.46675 7.26748 8.88221C6.92994 8.29763 7.13026 7.55013 7.71484 7.21263L11.9933 4.74244C12.4122 4.50065 12.9168 4.45734 13.3707 4.62429L15.6406 5.45922L18.1104 4.03332L21.8177 10.3506L20.0222 11.8287L12.3153 7.37914Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2437 10.8015L20.7134 12.2274C21.298 12.5649 21.4983 13.3124 21.1608 13.8969C20.8233 14.4815 20.0758 14.6818 19.4912 14.3444L17.0215 12.9185"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.021 12.9184L20.1964 14.7517C20.781 15.0892 20.9813 15.8367 20.6438 16.4213C20.3063 17.0058 19.5588 17.2062 18.9742 16.8687L15.7988 15.0353"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7984 15.0353L18.2681 16.4612C18.8527 16.7987 19.053 17.5462 18.7155 18.1308C18.378 18.7153 17.6305 18.9156 17.0459 18.5781L14.5762 17.1522"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5777 17.1522L15.989 17.967C16.5735 18.3045 16.7738 19.052 16.4363 19.6366C16.0988 20.2212 15.3513 20.4215 14.7668 20.084L13.3555 19.2692"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77345 18.3456C7.18883 18.0081 6.98855 17.2605 7.32608 16.676L8.34458 14.9119C8.68207 14.3273 9.42953 14.127 10.0142 14.4645C10.5987 14.802 10.799 15.5495 10.4615 16.1341L9.44298 17.8982C9.10549 18.4828 8.35803 18.6831 7.77345 18.3456Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.88864 19.5679C9.30406 19.2304 9.10378 18.4829 9.44132 17.8983L10.0524 16.8398C10.3899 16.2552 11.1374 16.055 11.7219 16.3925C12.3065 16.73 12.5068 17.4775 12.1693 18.062L11.5582 19.1205C11.2207 19.7051 10.4732 19.9054 9.88864 19.5679Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.53708 15.9011C2.9525 15.5636 2.75222 14.8161 3.08975 14.2316L4.10826 12.4675C4.44575 11.8828 5.19321 11.6826 5.77779 12.0201C6.36237 12.3576 6.56269 13.1051 6.22515 13.6897L5.20665 15.4538C4.86912 16.0383 4.12166 16.2386 3.53708 15.9011Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.65428 17.1234C5.0697 16.7859 4.86939 16.0384 5.20696 15.4538L6.63286 12.9841C6.97035 12.3995 7.71781 12.1992 8.30239 12.5367C8.88697 12.8742 9.08725 13.6217 8.74972 14.2063L7.32382 16.6761C6.98632 17.2606 6.23887 17.4609 5.65428 17.1234Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6493 6.6735L5.64948 4.94152L2.18164 11.407L4.08697 12.5071"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9434 18.4544L13.3546 19.2692"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
